<template>
    <video type="video" class="video-js vjs-16-9 vjs-big-play-centered transcoded-video-player" width="100%" ref="RowingVideoPlayer"></video>
</template>

<script>
    import videojs from 'video.js'
    import fileUtils from "@/mixins/file-utils";
    export default {
        mixins: [fileUtils],
        props: {
            videoFileId: {},
            posterFileId: {}
        },
        data() {
            return {
                player: null
            }
        },
        mounted() {
            let options = {
                sources: [{
                    type: 'video/mp4',
                    src: this.fileUrl(this.videoFileId)
                }],
                poster: this.posterFileId ? this.fileUrl(this.posterFileId) : null,
                preload: 'none',
                controls: true,
                playbackRates: [0.1, 0.2, 0.5, 1],
                aspectRatio: '16:9',
                muted: true
            }
            this.VjsPlayer = videojs(this.$refs.RowingVideoPlayer, options)
        },
        beforeDestroy() {
            if (this.VjsPlayer) {
                this.VjsPlayer.dispose()
            }
        }
    }
</script>

<style>

    .transcoded-video-player .vjs-time-control {
        display: block;
    }
</style>